
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meeting-events",
      function () {
        return require("private-next-pages/meeting-events/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meeting-events"])
      });
    }
  